

import { Navigate } from 'react-router-dom'
import {useEpisode} from '@/contexts/EpisodeContext'

export default function EpisodePage() {
  const {episode} = useEpisode()

  if(episode?.segments?.length > 0){
    return <Navigate to={`/show/episodes/${episode._id}/${episode.segments[0]._id}/script`} replace />
  }

  return (
    <div className='flex flex-col justify-center items-center h-full flex-1 select-none gap-4'>
        <div className='text-secondary-foreground/40 text-4xl font-bold'>Nothing to see here just yet</div>
        <div className='text-secondary-foreground/30 text-sm'>Start by creating a new segment</div>
    </div>
  )
}
